import { Routes, Route } from "react-router-dom";
import { Layout } from "antd";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LandingPage from "./pages/LandingPage";
import LanguageSwitcher from "./components/LanguageSwitcher";

const { Content } = Layout;

const App: React.FC = () => {
  return (
    <Layout className="layout">
      <LanguageSwitcher />
      <Header />
      <Content>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </Content>
      <Footer />
    </Layout>
  );
};

export default App;
